/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        globalNav: {
            container: {
                backgroundColor: {
                    value: "#282e37",
                    type: "color",
                },
                color: {
                    value: "#ffffff",
                    type: "color",
                },
                backdrop: {
                    backgroundColor: {
                        value: "#282e3780",
                        type: "color",
                    },
                },
            },
            header: {
                paddingTop: {
                    value: "12px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "12px",
                    type: "dimension",
                },
                height: {
                    value: "64px",
                    type: "dimension",
                },
                borderBottomColor: {
                    value: "#a0a2a5",
                    type: "color",
                },
            },
            list: {
                gap: {
                    value: "12px",
                    type: "dimension",
                },
                paddingTop: {
                    value: "12px",
                    type: "dimension",
                },
                paddingBottom: {
                    value: "12px",
                    type: "dimension",
                },
                item: {
                    padding: {
                        value: "12px",
                        type: "dimension",
                    },
                    gap: {
                        value: "12px",
                        type: "dimension",
                    },
                    borderRadius: {
                        value: "12px",
                        type: "dimension",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 400,
                        type: "number",
                    },
                    letterSpacing: {
                        value: 400,
                        type: "number",
                    },
                    default: {
                        backgroundColor: {
                            value: "transparent",
                            type: "color",
                        },
                        color: {
                            value: "#e6e6e6",
                            type: "color",
                        },
                    },
                    hover: {
                        backgroundColor: {
                            value: "#464e53",
                            type: "color",
                        },
                    },
                    open: {
                        default: {
                            backgroundColor: {
                                value: "#464e53",
                                type: "color",
                            },
                        },
                        hover: {
                            backgroundColor: {
                                value: "#6f7377",
                                type: "color",
                            },
                            boxShadow: {
                                value: {
                                    layers: [
                                        {
                                            inset: false,
                                            offsetX: "0px",
                                            offsetY: "2px",
                                            blur: "4px",
                                            spread: "0px",
                                            color: "#00000040",
                                        },
                                    ],
                                    stringValue: "0px 2px 4px 0px #00000040",
                                },
                                type: "shadow",
                            },
                        },
                    },
                    current: {
                        backgroundColor: {
                            value: "#d3222a",
                            type: "color",
                        },
                        color: {
                            value: "#ffffff",
                            type: "color",
                        },
                    },
                },
                divider: {
                    borderWidth: {
                        value: "1px",
                        type: "dimension",
                    },
                    borderColor: {
                        value: "#a0a2a5",
                        type: "color",
                    },
                    borderStyle: {
                        value: "solid",
                        type: "stokeStyle",
                    },
                    marginTop: {
                        value: "12px",
                        type: "dimension",
                    },
                    marginBottom: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
            menuButton: {
                default: {
                    backgroundColor: {
                        value: "transparent",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#454d59",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                active: {
                    backgroundColor: {
                        value: "#606c7f",
                        type: "color",
                    },
                    color: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
                focus: {
                    outlineColor: {
                        value: "#ffffff",
                        type: "color",
                    },
                },
            },
            expanded: {
                width: {
                    value: "300px",
                    type: "dimension",
                },
                list: {
                    paddingLeft: {
                        value: "12px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "12px",
                        type: "dimension",
                    },
                },
            },
            collapsed: {
                width: {
                    value: "64px",
                    type: "dimension",
                },
                header: {
                    height: {
                        value: "116px",
                        type: "dimension",
                    },
                },
                list: {
                    paddingLeft: {
                        value: "8px",
                        type: "dimension",
                    },
                    paddingRight: {
                        value: "8px",
                        type: "dimension",
                    },
                },
            },
        },
    },
};
export default tokens;
